export default {
  title: 'The import is in progress... 🙂',
  description: 'Slack notifications will be sent when the import is finished.',
  buttons: {
    open_followers_list: 'Open followers list',
  },
};
